const Navbar = () => {
    return (
       <div>
        <section className="container">
            <h2 className="title">
                <span className="primary">Meet our team</span>
                <span className="secondary">Lorem, ipsum dolor.</span>
            </h2>
            <div className="gallery-wrapper">
                <div className="gallery-item">
                    <img src="https://www.afisha.uz/uploads/media/2020/09/0122753_m.png" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://api.uznews.uz/upload/20200218135120k.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://avatars.mds.yandex.net/get-altay/402558/2a000001856cee3be176048f665a6f65c78f/orig" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://xabar.uz/static/crop/2/9/920__95_2928721411.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://fergana.agency/siteapi/media/images/4a01c0b4-1b49-4504-b18d-ea943f721f2e.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://anons.uz/media/news/medium/IMG_0420__%D0%BA%D0%BE%D0%BF%D0%B8%D1%8F_watermarked.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
            </div>
        </section>
        <section className="container">
            <h2 className="title">
                <span className="primary">Meet our team</span>
                <span className="secondary">Lorem, ipsum dolor.</span>
            </h2>
            <div className="gallery-wrapper">
                <div className="gallery-item">
                    <img src="https://www.afisha.uz/uploads/media/2020/09/0122753_m.png" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://api.uznews.uz/upload/20200218135120k.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://avatars.mds.yandex.net/get-altay/402558/2a000001856cee3be176048f665a6f65c78f/orig" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://xabar.uz/static/crop/2/9/920__95_2928721411.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://fergana.agency/siteapi/media/images/4a01c0b4-1b49-4504-b18d-ea943f721f2e.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://anons.uz/media/news/medium/IMG_0420__%D0%BA%D0%BE%D0%BF%D0%B8%D1%8F_watermarked.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
            </div>
        </section>
        <section className="container">
            <h2 className="title">
                <span className="primary">Meet our team</span>
                <span className="secondary">Lorem, ipsum dolor.</span>
            </h2>
            <div className="gallery-wrapper">
                <div className="gallery-item">
                    <img src="https://www.afisha.uz/uploads/media/2020/09/0122753_m.png" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://api.uznews.uz/upload/20200218135120k.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://avatars.mds.yandex.net/get-altay/402558/2a000001856cee3be176048f665a6f65c78f/orig" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://xabar.uz/static/crop/2/9/920__95_2928721411.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://fergana.agency/siteapi/media/images/4a01c0b4-1b49-4504-b18d-ea943f721f2e.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://anons.uz/media/news/medium/IMG_0420__%D0%BA%D0%BE%D0%BF%D0%B8%D1%8F_watermarked.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
            </div>
        </section>
        <section className="container">
            <h2 className="title">
                <span className="primary">Meet our team</span>
                <span className="secondary">Lorem, ipsum dolor.</span>
            </h2>
            <div className="gallery-wrapper">
                <div className="gallery-item">
                    <img src="https://www.afisha.uz/uploads/media/2020/09/0122753_m.png" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://api.uznews.uz/upload/20200218135120k.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://avatars.mds.yandex.net/get-altay/402558/2a000001856cee3be176048f665a6f65c78f/orig" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://xabar.uz/static/crop/2/9/920__95_2928721411.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://fergana.agency/siteapi/media/images/4a01c0b4-1b49-4504-b18d-ea943f721f2e.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://anons.uz/media/news/medium/IMG_0420__%D0%BA%D0%BE%D0%BF%D0%B8%D1%8F_watermarked.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
            </div>
        </section>
        <section className="container">
            <h2 className="title">
                <span className="primary">Meet our team</span>
                <span className="secondary">Lorem, ipsum dolor.</span>
            </h2>
            <div className="gallery-wrapper">
                <div className="gallery-item">
                    <img src="https://www.afisha.uz/uploads/media/2020/09/0122753_m.png" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://api.uznews.uz/upload/20200218135120k.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://avatars.mds.yandex.net/get-altay/402558/2a000001856cee3be176048f665a6f65c78f/orig" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://xabar.uz/static/crop/2/9/920__95_2928721411.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://fergana.agency/siteapi/media/images/4a01c0b4-1b49-4504-b18d-ea943f721f2e.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://anons.uz/media/news/medium/IMG_0420__%D0%BA%D0%BE%D0%BF%D0%B8%D1%8F_watermarked.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
            </div>
        </section>
        <section className="container">
            <h2 className="title">
                <span className="primary">Meet our team</span>
                <span className="secondary">Lorem, ipsum dolor.</span>
            </h2>
            <div className="gallery-wrapper">
                <div className="gallery-item">
                    <img src="https://www.afisha.uz/uploads/media/2020/09/0122753_m.png" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://api.uznews.uz/upload/20200218135120k.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://avatars.mds.yandex.net/get-altay/402558/2a000001856cee3be176048f665a6f65c78f/orig" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://xabar.uz/static/crop/2/9/920__95_2928721411.jpg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://fergana.agency/siteapi/media/images/4a01c0b4-1b49-4504-b18d-ea943f721f2e.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
                <div className="gallery-item">
                    <img src="https://anons.uz/media/news/medium/IMG_0420__%D0%BA%D0%BE%D0%BF%D0%B8%D1%8F_watermarked.jpeg" alt="" className="item-image"/>
                    <figcaption className="item-description">
                        <h2 className="name">Jane Doe</h2>
                        <span className="role">Director</span>
                            </figcaption> 
                </div>
            </div>
        </section>
       </div>
    );
};

export default Navbar;